// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {Grid, makeStyles, Typography} from '@material-ui/core';

import {colors} from '../../../../../assets/styles/colors';

import type {Theme} from '@material-ui/core';
import type {Node} from 'react';

type Props = {
  title: string,
  children?: Node,
  action?: Node,
};

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    padding: theme.spacing(2),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: colors.grey900,
    fontSize: 16,
    fontWeight: 600,
  },
}));
export default function Section(props: Props) {
  const {title, children, action} = props;
  const classes = useStyles();
  return (
    <section className={classes.section}>
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.header}>
            <Typography className={classes.title}>{title}</Typography>
            <div className={classes.actionWrap}>{action}</div>
          </div>
        </Grid>
        {!!children && (
          <Grid item xs={12}>
            <div>{children}</div>
          </Grid>
        )}
      </Grid>
    </section>
  );
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  action: PropTypes.node,
};
